<!-- button to show/hide SABIS AI -->
<button [style.display]="isChatbotVisible ? 'none' : null" #floatingButton
        appDraggable
        [defaultBottom]="floatingButtonBottom"
        [defaultRight]="floatingButtonRight"
        [onClickCallback]="onClickBound"
        class="floating-button"
        [disabled]="!isNetworkOnline">
    @if (!isNetworkOnline) {
    <img class="floating-img" src="assets/icons/chatbot-floating-button-offline.png" alt="Floating Button" />
    } @else {
    <img class="floating-img" [ngClass]="{'glowing-circle': isResponseReady}" src="assets/icons/chatbot-avatar-icon-new.svg"
         alt="Floating Button" />
    }
</button>

<!-- SABIS AI actual UI element -->
@if (isChatbotVisible || isChatbotMinimized) {
<sabis-chatbot-popup [style.display]="isChatbotVisible ? null : 'none'"
                     [config]="chatbotConfig"
                     [customCssClass]="customCssClass"
                     (close)="onCloseChatbotPopup()"
                     (minimize)="onMinimizeChatbotPopup()"
                     [isSessionIdVisible]="isSessionIdVisible"
                     (contentClick)="onContentClick($event)" />
}
